import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=63fc44d3&scoped=true"
import script from "./effect.vue?vue&type=script&lang=js"
export * from "./effect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc44d3",
  null
  
)

export default component.exports